module.exports = __webpack_public_path__ + "static/media/TLDR_8_expertise.1cdcd970.png";